import type { JSX, ReactNode } from 'react'

import { useMemo, useRef } from 'react'
import { usePointerDownOutside } from 'utils/hooks'
import { SearchAutocompleteListContext } from './SearchAutocompleteListContext'
import { SearchAutocompleteMenuSC } from './SearchAutocompleteMenu.styled'
import { useSearchAutocompleteListNavigation } from './useSearchAutocompleteListNavigation'

export interface ISearchAutocompleteMenuProps {
  children: ReactNode
  onClose: () => void
  autocompleteItemCount?: number
}

export const SearchAutocompleteMenu = ({
  children,
  onClose,
  autocompleteItemCount,
}: ISearchAutocompleteMenuProps): JSX.Element => {
  const rootRef = useRef<HTMLDivElement>(null)

  const { highlightedIndex, setHighlightedIndex, setPick, stableOnClose } =
    useSearchAutocompleteListNavigation({ onClose, autocompleteItemCount })

  usePointerDownOutside(rootRef, stableOnClose)

  const listContext = useMemo(
    () => ({
      highlightedIndex,
      setHighlightedIndex,
      setPick,
    }),
    [highlightedIndex, setPick]
  )

  return (
    <SearchAutocompleteListContext.Provider value={listContext}>
      <SearchAutocompleteMenuSC ref={rootRef} role='listbox'>
        {children}
      </SearchAutocompleteMenuSC>
    </SearchAutocompleteListContext.Provider>
  )
}
